const Config = {
  BASE_URL: `${process.env.BASE_URL}${process.env.BASE_PORT ? ':' + process.env.BASE_PORT : ''}`
}

export { Config }
